import { CommonStyles, cssClass, Style, textEllipsis } from '../../../common/styles/CommonStyles';
import { style } from 'typestyle';

export const THUMBNAIL_HEIGHT = 184;
const THUMBNAIL_BORDER_HEIGHT = 2; // 1px top and bottom
const CARD_INFO_HEIGHT = 30;
const PRIMARY_FONT_SIZE = 14;
export const CARD_SUBSECTION_HEIGHT = 50;

export const TOTAL_CARD_HEIGHT = THUMBNAIL_HEIGHT + THUMBNAIL_BORDER_HEIGHT + CARD_INFO_HEIGHT + CARD_SUBSECTION_HEIGHT;
export const TOTAL_CARD_WIDTH = 300;

const BOX_SHADOW = `0px 1px 2px rgba(0,0,0,.15)`;
const BORDER = '1px solid #d8d8d8';
const CARD_BUTTON_DIMENSION = 30;
const HORIZONTAL_MARGIN_BTWN_CARDS = 32;

export namespace CardViewStyles {
  const BaseCardStyle: Style = {
    fontWeight: 'normal',
    // Many thumbnail elements have a hardcoded positive z-index; explicitly declaring 0 here
    // forces a new stacking context so the thumbnail doesn't float above other elements such as dropdowns
    zIndex: 0,
    width: TOTAL_CARD_WIDTH,
    fontSize: PRIMARY_FONT_SIZE,
  };

  export const Links = { display: 'inline', marginLeft: '0px' };

  const ThumbnailBaseStyle: Style = {
    display: 'block',
    height: THUMBNAIL_HEIGHT,
    backgroundRepeat: 'no-repeat',
    boxSizing: 'border-box',
  };

  export const ThumbnailPreloaded = cssClass('CardView-thumbnail-preloaded', ThumbnailBaseStyle);

  export const Thumbnail = cssClass('CardView-thumbnail', ThumbnailBaseStyle, {
    backgroundColor: CommonStyles.Colors.Grey250,
    backgroundPosition: 'center',
  });

  export const Card = cssClass('CardView-card-inner', BaseCardStyle, {
    $nest: {
      '&>span': {
        display: 'block',
      },
    },
  });

  // Workbook thumbnails are decorated to look like a stack of cards.
  const ThumbnailWorkbookDecorationBase: Style = {
    display: 'block',
    height: THUMBNAIL_HEIGHT,
    boxShadow: BOX_SHADOW,
    backgroundColor: CommonStyles.Colors.White,
    position: 'absolute',
  };

  const WorkbookDecorationSpacing = 9;

  export const ThumbnailWorkbookDecoration = cssClass('CardView-thumbnail-workbook-decoration', {
    ...ThumbnailWorkbookDecorationBase,
    width: TOTAL_CARD_WIDTH - WorkbookDecorationSpacing * 2,
    top: WorkbookDecorationSpacing,
    left: WorkbookDecorationSpacing,
    zIndex: -1,
    $nest: {
      '&::before': {
        ...ThumbnailWorkbookDecorationBase,
        content: `''`,
        width: TOTAL_CARD_WIDTH - WorkbookDecorationSpacing,
        top: -4,
        left: -4,
      },
    },
  });

  export const ActionRow = cssClass('CardView-action-row', {
    display: 'flex',
    height: CARD_INFO_HEIGHT,
    justifyContent: 'space-between',
    paddingLeft: CommonStyles.Spacing.MediumSpace,
    paddingRight: CommonStyles.Spacing.SmallSpace,
    $nest: {
      '&>*': {
        height: CARD_BUTTON_DIMENSION,
        paddingRight: CommonStyles.Spacing.DefaultSpace,
      },
    },
  });

  const ActionRowNameStyle = {
    fontWeight: 500,
    flex: '1',
    fontSize: PRIMARY_FONT_SIZE,
    paddingRight: CommonStyles.Spacing.MediumSpace,
    paddingTop: CommonStyles.Spacing.SmallSpace,
  };

  export const ActionRowName = cssClass('CardView-action-row-name', { ...textEllipsis, ...ActionRowNameStyle });

  export const Section = style({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'start',
  });

  export const SectionCardDimensions = style({
    width: TOTAL_CARD_WIDTH,
    marginRight: HORIZONTAL_MARGIN_BTWN_CARDS,
    marginTop: 18,
    marginLeft: 2,
    marginBottom: 22,
  });

  export const CardContainer = style({
    $nest: {
      'a.thumbnail-link:focus': {
        border: `1px solid ${CommonStyles.Colors.FocusBorderBlue} !important`,
        boxShadow: `0 0 4px 0 ${CommonStyles.Colors.FocusBorderBlue} !important`,
      },
      'a.thumbnail-link': {
        border: BORDER,
        borderRadius: 1,
        boxShadow: BOX_SHADOW,
        height: '100%',
        display: 'block',
      },
    },
  });

  export const SubSection = cssClass('Cardview-subsection', {
    textOverflow: 'ellipsis',
    color: CommonStyles.Colors.Grey102,
    paddingLeft: CommonStyles.Spacing.MediumSpace,
    paddingRight: CommonStyles.Spacing.SmallSpace,
    lineHeight: '20px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  });

  export const InfoButton = cssClass('Cardview-info-button', {
    padding: '0',
    margin: '0',
    height: '19px',
    background: 'none',
    border: '1px solid transparent',
    borderRadius: '2px',
    cursor: 'pointer',
    $nest: {
      '&:hover': {
        backgroundColor: CommonStyles.Colors.Grey235,
      },
      '&:active': {
        backgroundColor: CommonStyles.Colors.Grey235,
      },
      '&:focus': {
        borderColor: CommonStyles.Colors.FocusBorderBlue,
        boxShadow: '0 0 4px 0 ' + CommonStyles.Colors.FocusBorderBlue,
        outline: 'none',
      },
    },
  });
}
